import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NegotiationsState } from './negotiations.reducer';

export const selectNegotiationsFeature =
  createFeatureSelector<NegotiationsState>('negotiations');

export const selectNegotiations = createSelector(
  selectNegotiationsFeature,
  (state) => state.negotiations
);

export const selectActiveNegotiations = createSelector(
  selectNegotiationsFeature,
  (state) => state.negotiations?.filter((n) => n.status === 'Active')
);
